<template>
  <div class="relative flex justify-center items-center w-full h-full">
    <template v-if="isRelax">
      <img class="relaxZoom mb-20" src="../../assets/Tutorial/fullBody.svg" />
    </template>
    <template v-else>
      <img class="clenchZoom mb-20" src="../../assets/Tutorial/fistBody.svg" />
      <div class="absolute flex justify-center items-center z-20">
        <img class="mr-20" src="../../assets/Tutorial/blueCircle.svg" />
        <img src="../../assets/Tutorial/blueCircle.svg" />
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'FullBody',
  props: {
    isRelax: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.relaxZoom {
  min-width: 63%;
  @apply w-2/3;
}
.clenchZoom {
  min-width: 88%;
  @apply w-2/3;
}
</style>
